import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  lead?: string;
  align?: 'left' | 'center';
  className?: string;
  titleClassName?: string;
}

const SectionHeading = forwardRef<HTMLDivElement, SectionHeadingProps>(({
  eyebrow,
  title,
  lead,
  align = 'center',
  className,
  titleClassName,
}, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'mb-12 md:mb-16',
        align === 'center' && 'text-center',
        className
      )}
    >
      {eyebrow && (
        <span className="eyebrow text-foreground/70 block">{eyebrow}</span>
      )}
      <h2
        className={cn(
          'display-h2 text-foreground',
          align === 'center' && 'mx-auto',
          titleClassName
        )}
      >
        {title}
      </h2>
      {lead && (
        <p
          className={cn(
            'lead text-foreground/85 mt-5',
            align === 'center' && 'mx-auto'
          )}
        >
          {lead}
        </p>
      )}
    </div>
  );
});

SectionHeading.displayName = 'SectionHeading';

export default SectionHeading;
